module.exports = __webpack_public_path__ + "static/pegasus-ac28389fd998ecf20d535de035d0e137.jpg";